<template>
    <div class="yk-code">
        <img class="notice-img" @click="handleNoticeClick" src="../../static/assets/image/notice-icon.png" />
        <img class="code-img" src="../../static/assets/image/yk-code.png" />
    </div>
</template>
<script>
import config from '@/util/config';

export default {
    methods: {
        handleNoticeClick() {
            const url = `${config.getUrl()}/news.html#/detail?id=94`;
            window.location.href = url;
        }
    }
};
</script>
<style lang="scss" scoped>
.yk-code {
    position: fixed;
    top: 51%;
    right: 35px;
    width: 204px;
    margin-top: -121px;
    height: 242px;
    z-index: 2;
    .notice-img {
        width: 184px;
    }
    .code-img {
        // position: absolute;
        // top: 50%;
        // left: 50%;
        width: 100%;
        // transform: translate(-50%, -50%);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/h-code.vue